import React from 'react';

interface MaintenancePageProps {
  message?: string;
}

const MaintenancePage: React.FC<MaintenancePageProps> = ({ 
  message = 'System is under maintenance. Please check back soon.' 
}) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 bg-white p-8 rounded-lg shadow-md">
        <div className="text-center">
          {/* Construction icon using SVG */}
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            className="h-20 w-20 mx-auto text-yellow-500" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" 
            />
          </svg>
          
          <h1 className="mt-6 text-3xl font-extrabold text-gray-900">
            Maintenance in Progress
          </h1>
          
          <p className="mt-2 text-sm text-gray-500">
            {message}
          </p>
        </div>
        
        <div className="mt-8 text-center">
          <p className="text-xs text-gray-400">
            We'll be back shortly. Thank you for your patience.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
